import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const TimeOutModal = ({
  showModal,
  handleClose,
  handleLogout,
  minutes,
  seconds,
  timeOutType
}) => {
  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{timeOutType.charAt(0).toUpperCase() + timeOutType.slice(1).toLowerCase()} Reminder</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Your {timeOutType} session will time out in {minutes}:{seconds}. Do you
        wish to continue {timeOutType}?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Stay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
